
import { useState } from "react";
import { Copy, Check, ExternalLink } from "lucide-react";
import { eventConfig } from "../../pages/services/eventConfig";

export default function PaymentInstructions({
  method,
  total,
  reference,
}) {
  const [copied, setCopied] = useState(false);

  const payment = eventConfig.paymentMethods[method];

  if (!payment) return null;

  const copyReference = async () => {
    try {
      await navigator.clipboard.writeText(reference);
      setCopied(true);
    } catch (error) {
      console.error("Unable to copy reference:", error);
    }
  };

  return (
    <div className="mt-6 overflow-hidden rounded-2xl border border-gray-200 bg-gray-50">
      <div className="border-b border-gray-200 bg-white px-6 py-5">
        <h3 className="text-xl font-extrabold text-[#3E2C20]">
          Pay with {payment.label}
        </h3>

        <p className="mt-1 text-sm text-gray-500">
          Scan the QR code or follow the instructions below.
        </p>
      </div>

      <div className="space-y-6 p-6">
        <div className="text-center">
          <p className="text-sm font-semibold text-gray-500">
            Amount to Send
          </p>

          <p className="mt-1 text-4xl font-extrabold text-[#3E2C20]">
            ${total.toFixed(2)}
          </p>
        </div>

        {/* CLIENT'S QR CODE IMAGE */}
        <div className="flex justify-center">
          <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
            <img
              src={payment.qrImage}
              alt={`${payment.label} payment QR code`}
              className="h-52 w-52 object-contain"
            />
          </div>
        </div>

        <div className="text-center">
          <p className="text-sm text-gray-500">
            Send payment to
          </p>

          <p className="mt-2 break-all text-xl font-extrabold text-[#3E2C20]">
            {payment.recipient}
          </p>

          {payment.url && (
            <a
              href={payment.url}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center justify-center gap-2 rounded-xl bg-green-700 px-6 py-3 font-bold text-white transition hover:bg-green-800"
            >
              Open {payment.label}
              <ExternalLink size={17} />
            </a>
          )}
        </div>

        {/* REGISTRATION REFERENCE */}
        <div className="rounded-xl border border-yellow-200 bg-yellow-50 p-5">
          <p className="text-sm font-bold text-gray-800">
            Registration Reference
          </p>

          <div className="mt-3 flex flex-wrap items-center justify-between gap-3 rounded-lg bg-white p-4">
            <span className="break-all font-extrabold text-[#3E2C20]">
              {reference}
            </span>

            <button
              type="button"
              onClick={copyReference}
              className="flex items-center gap-2 rounded-lg bg-gray-100 px-3 py-2 text-sm font-bold text-gray-700 hover:bg-gray-200"
            >
              {copied ? <Check size={16} /> : <Copy size={16} />}
              {copied ? "Copied" : "Copy"}
            </button>
          </div>

          <p className="mt-3 text-xs leading-5 text-gray-600">
            Include this reference in your payment memo
            where supported so the organizer can identify
            your registration.
          </p>
        </div>

        <p className="text-center text-xs leading-5 text-gray-500">
          Your registration will remain pending until
          the event organizer verifies your payment.
        </p>
      </div>
    </div>
  );
}
